<div class="content-page">
  <div class="d-flex gap-3 gap-xxl-5 justify-content-between align-items-center">
    <img src="assets/images/kaizen-logo.webp" 
    alt="logo" width="120" class="pointer logo-header d-block d-lg-none" (click)="goTo('/', 0)">
    <img [src]="showFooter || scrolled ? 'assets/images/kaizen-logo.webp' : 'assets/images/kaizen-logo-white.webp'" 
    alt="logo" width="208" class="pointer logo-header d-none d-lg-block" (click)="goTo('/', 0)">
    <div class="d-none d-lg-flex align-items-center content-menu-options">
      <ng-container *ngFor="let item of menu; let i = index">
        <div
          class="option-menu pointer px-2"
          [class.platform]="i === 3"
          [class.not-platform]="i !== 3"
          (click)="goTo(item.url, i)"
        >
          <span [class.text-white]="i === 3">{{ item.name }}</span>
          <div class="line" [routerLink]="item.url" routerLinkActive="selected"></div>
        </div>
      </ng-container>
    </div>
    <img src="assets/svg/icon-menu.svg" alt="menu" width="24" class="pointer d-lg-none d-flex" (click)="toggleMenu()">
  </div>
</div>

<div class="side-panel" [class.open]="menuOpen">
  <div>
    <div class="side-top">
      <div class="side-header d-flex justify-content-between align-items-center">
        <img src="assets/images/kaizen-logo.webp" alt="logo" width="150" class="logo-header">
      </div>

      <div class="side-content mt-4">
        <ng-container *ngFor="let item of menu; let i = index">
          <a [routerLink]="item.url" (click)="toggleMenu()" class="menu-link d-block mb-3 text-blue fs-6" *ngIf="i < 3">{{ item.name }}</a>
        </ng-container>
      </div>
    </div>
    <hr>
    <div class="side-bottom">
      <a href="https://backoffice.capitalkaizen.com/" target="_blank" class="menu-link d-block mb-3 text-blue fs-6">Plataforma asesores</a>
    </div>
  </div>

  <div class="d-flex gap-3 align-items-start content-icons-social justify-content-start">
    <img src="assets/svg/icon-linkdn.svg" alt="logo" width="24">
    <img src="assets/svg/icon-instagram.svg" alt="logo" width="24">
    <img src="assets/svg/icon-twitter.svg" alt="logo" width="24">
  </div>

</div>

<div class="overlay" [class.active]="menuOpen" (click)="toggleMenu()"></div>